import React from "react";
import {NomenclaturesPage} from "./NomenclaturesPage";
import {useNomenclatures} from "./useNomenclatures";

function Nomenclatures(props) {
  return <NomenclaturesPage {...useNomenclatures(props)} />;
}

export default Nomenclatures;
